import React, { BaseSyntheticEvent, FC } from "react";
import { CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PageQr from "./img/page-qr.svg";

type Props = {
  show: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
};

export const QRModal: FC<Props> = ({ show, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "confirmModal") onCancel();
  };

  const handlerShowAgain = (checked: boolean) => {
    localStorage.setItem("isShowAgain", JSON.stringify(!checked));
  };

  return (
    <div
      id="confirmModal"
      className={`modal ${show ? "show d-flex" : ""} align-items-center justify-content-center`}
      style={{
        display: show ? "block" : "none",
        background: "rgb(0, 0, 0, 0.6)",
      }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="modal-dialog">
        <div className="modal-content position-relative d-flex flex-column align-items-center px-4 pt-5">
          <CloseButton
            onClick={onCancel}
            className="position-absolute top-0 mt-3 me-3"
            style={{ height: "16px", width: "16px", opacity: "1", right: 0 }}
          />
          <h5 className="fw-700 fs-3 text-center mb-3 col-12 col-md-9">
            {t("qr.modalTitle")}
          </h5>
          <img className="mb-3" width={164} src={PageQr} alt="page qr code" />
          <div className="col-9 border-0 text-center mb-3 text-gray">
            {t("qr.modalDescr")}
          </div>
          <button
            type="button"
            className="btn btn btn-primary fs-6 text-white col-12 py-3"
            style={{ margin: "12px 0" }}
            onClick={onConfirm}
          >
            {t("qr.toMyProject")}
          </button>
          <div className="d-none d-md-flex align-items-center justify-content-center mb-4 w-100">
            <input
              name="again"
              type="checkbox"
              onChange={(e: BaseSyntheticEvent) =>
                handlerShowAgain(e.target.checked)
              }
              className="form-check-input m-0"
              id="again"
            />
            <label
              htmlFor="again"
              className="form-label fs-7 text-dark ps-2 m-0"
            >
              {t("qr.again")}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
